import Typography from 'APP/Converse/Typography'
import React from 'react'
import i18n from 'APP/I18n'
import AddUserIcon from 'react-native-vector-icons/Ionicons'
import { TEST_IDS } from '../constants'
import { ToolTipContainer, Header } from '../styles'
import { useTheme } from 'styled-components/native'

const AdultToolTip = () => {
  const { colors } = useTheme()
  return (
    <ToolTipContainer testID={TEST_IDS.ADULT_TOOLTIP}>
      <Header>
        <AddUserIcon name="person-add-outline" size={14} color={colors.accent} />
        <Typography variant="subheader">{i18n.t('AddDependent.tooltip.title')}</Typography>
      </Header>
      <Typography variant="bodySmall">{i18n.t('AddDependent.tooltip.description')}</Typography>
    </ToolTipContainer>
  )
}

export default AdultToolTip
